export default __webpack_public_path__ + "static/media/american-express-card-selected.97b509aa.svg";